import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// legacy.css first — it is the theme layer every rule below builds on, and the
// files after it deliberately override a few of its defaults.
import './assets/css/legacy.css';
import './assets/css/updates.css';
import './assets/css/common.css';
import './assets/css/layout.css';
import './assets/css/activity.css';
import './assets/css/notifications.css';
import './assets/css/settings.css';
import './assets/css/payouts.css';
import './assets/css/tests.css';
import './assets/css/analytics.css';
import './assets/css/overview.css';
import './assets/css/overview-v2.css';
import './assets/css/overview-v3.css';
import './assets/css/campaigns.css';
import './assets/css/custom.css';
import './assets/css/archive.css';
import App from './App.jsx';

/*
 * The app is served at the root — public/index.html is gone. If it is ever moved
 * back under a prefix, `basename` here and `base` in vite.config.mjs have to
 * move together.
 */
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
